import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { startLogout } from '../actions/auth';

export const Header = ({ startLogout }) => (
  <header className="header">
    <div className="content-container">
      <div className="header__content">
        <div className="header__title" to="/expense/dashboard">
          <h1>
            Thrifti
            <NavLink className="header__menu" to="/expense/dashboard" activeClassName="header__menu--active">expense</NavLink>
            <NavLink className="header__menu" to="/income/dashboard" activeClassName="header__menu--active">income</NavLink>
          </h1>
        </div>
        <button className="button button--link" onClick={startLogout}>Logout</button>
      </div>
    </div>
  </header>
);

const mapDispatchToProps = (dispatch) => ({
  startLogout: () => dispatch(startLogout())
});

export default connect(undefined, mapDispatchToProps)(Header);